import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const usePlatform = () => {
  const router = useRouter();
  const [isRn, setIsRn] = useState(false);
  const isMobilePath = router.pathname.startsWith('/m');

  useEffect(() => {
    if (typeof window !== 'undefined' && (window as any).isRNWebview) {
      setIsRn(true);
    }
  }, []);

  return { isMobilePath, isRn };
};

export default usePlatform;
